<template>
  <div>
    <v-autocomplete
      @input="event => { this.$emit('input', event) }"
      :label="label ? label : $t('message.search_academies')"
      :loading="loading"
      outlined
      dense
      :items="items"
      item-text="name"
      item-value="_id"
      :search-input.sync="search"
      v-model="selectedValue"
      hide-details
      hide-no-data
    >
    </v-autocomplete>
    <p v-if="!hideMessage" 
      class="text-small text-left">
      {{$t('message.dont_see_academy')}} 
      <a @click="navigateTo({ name: 'addacademy', query: { from: from ? from : '' } })">
        {{$t('message.here')}}
      </a>
    </p>
  </div>
</template>
<script>
import AcademyService from "@/services/AcademyService";

export default {
  data() {
    return {
      loading: false,
      items: /** @type {{_id:string,name:string}[]} */ ([]),
      search: null,
      selectedValue: null,
      academies: /** @type {{_id:string,name:string}[]} */ ([]),
      searchTimer: 0
    };
  },
  components: {
  },
  props: {
    value: null,
    from: null,
    hideMessage: null,
    label: null
  },
  created() {},
  mounted() {},
  watch: {
    value: {
      immediate: true,
      handler: function(newValue) {
        this.selectedValue = newValue;
      }
    },
    search(val) {
      this.querySelections(val);
    }
  },
  methods: {
    async querySelections(v = "") {
      if (this.academies.length === 0) {
        this.loading = true;
        const data = await AcademyService.academiesSimplified();
        if (data) {
          this.academies = data.academies;
          // Filter and set items in the same tick so Vuetify sees one update
          this.items = this.academies.filter(e =>
            (e.name || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
          );
        }
        this.loading = false;
        return;
      }
      this.items = this.academies.filter(e =>
        (e.name || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
      );
    }
  }
};
</script>

<style scoped>
</style>
